import createItemOperation from 'owa-service/lib/operation/createItemOperation';
import createItemRequest from 'owa-service/lib/factory/createItemRequest';
import itemResponseShape from 'owa-service/lib/factory/itemResponseShape';
import propertyUri from 'owa-service/lib/factory/propertyUri';
import { getComposeItemResponseShape } from '../utils/getItemResponseShape';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
function createRequestBodyFromItem(itemType, bodyType, isSend, timeFormat, isInlineCompose, IRMData) {
    var request = createItemRequest({
        ClientSupportsIrm: true,
        ComposeOperation: 'newMail',
        MessageDisposition: isSend ? 'SendAndSaveCopy' : 'SaveOnly',
        OutboundCharset: 'AutoDetect',
        Items: [itemType],
        TimeFormat: timeFormat,
        SendOnNotFoundError: true,
        ItemShape: itemResponseShape({
            // Pass IdOnly as ShapeName here so that the response will contain LastModifiedTime
            BaseShape: 'IdOnly',
            AdditionalProperties: [propertyUri({ FieldURI: 'ItemLastModifiedTime' })],
        }),
    });
    if (IRMData && IRMData.IsOwner) {
        // If no encryption, need to explicitly set complianceId to '0' to remove any pre set IRM state
        request.ComplianceId = IRMData.RmsTemplateId ? IRMData.RmsTemplateId.toUpperCase() : '0';
    }
    if (!isSend) {
        request.ItemShape = getComposeItemResponseShape(bodyType);
        request.ShapeName = 'MailCompose';
    }
    else if (isInlineCompose) {
        // If sending from inlineCompose, request the internetMessageId in case we don't have it yet.
        request.ItemShape.ReturnOnlyInternetMessageId = true;
    }
    return request;
}
export default function createItem(itemType, bodyType, isSend, timeFormat, isInlineCompose, IRMData) {
    var requestBody = createRequestBodyFromItem(itemType, bodyType, isSend, timeFormat, isInlineCompose, IRMData);
    return createItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(function (response) {
        return response
            ? Promise.resolve(response.Body)
            : Promise.reject(new Error('ErrorSessionTimeout')); // When get HTTP 401/440, the response will be null
    });
}
//# sourceMappingURL=createItem.js.map